module.exports = __webpack_public_path__ + "img/template1.267fff8e.jpg";